<template>
  <div class="header">

    <!-- Logo -->
    <h1>
      <router-link to="/" class="ir">My Web App</router-link>
    </h1>

    <!-- Mobile Button -->
    <a href="#" data-target="slide-out" class="sidenav-trigger" id="mobile-btn">
      <i class="xi-bars"></i>
    </a>

  </div>
</template>

<script>
export default {
  name: "Header"
}
</script>

<style lang="scss" scoped>
  @import '../../sass/partials/_variable.scss', '../../sass/partials/_reset.scss';

  .header{
    width: 100%;
    height: 60px;
    background-color: $primary2;
    position: fixed; left: 0; top: 0;
    z-index: 10;

    // Logo
    h1{
      width: 42px;
      height: 42px;
      position: relative; top: 10px; left: 10px;

      a{
        background-image: url(../../assets/images/logo.png);
        background-size: 100%;
      }
    }

    // Mobile Button
    #mobile-btn{
      display: block;
      width: 44px;
      height: 34px;
      position: absolute; right: 20px; top: 13px;
      background-color: $primary1;
      text-align: center;
      line-height: 34px;
      font-size: 2.5rem;
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/component/Header.vue